import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableExternalResources from './tableExternalResources';
import tableVodCatalog from './tableVodTemplateCatalog'

export default {
  title: 'Source File',
  attributeName: 'sourceFilesFormGroup',
  fields: [
   {
      attributeName: 'storageProvider',
      type: FormInputTypes.SELECT,
      label: 'Storage service',
      helpText: 'Select location of the input file',
      errorText: '',
      options: [
        { name: 'Choose Video location', value: 'undefined'},
        { name: 'File Upload SFTP', value: 'SFTP' },
        { name: 'File Upload S3', value: 'ownS3' },
        { name: 'File Upload GCS', value: 'ownGCS' },
        { name: 'External GCS', value: 'externalGCS' },
        { name: 'External S3', value: 'awsS3' },
        { name: 'External Wasabi S3', value: 'wasabiS3' },
        
      ],
    },          
    {
      label: 'Videos',
      attributeName: 'externalResources',
      type: FormInputTypes.TABLE,
      label: '',
      helpText: '',
      configFile: tableExternalResources,
      visibleWhen: {"field":"storageProvider","value":"awsS3"}
    },  
     {
      label: 'Videos',
      attributeName: 'externalResources',
      type: FormInputTypes.TABLE,
      label: '',
      helpText: '',
      configFile: tableExternalResources,
      visibleWhen: {"field":"storageProvider","value":"wasabiS3"}
    },  
    {
      label: 'Videos',
      attributeName: 'externalResources',
      type: FormInputTypes.TABLE,
      label: '',
      helpText: '',
      configFile: tableExternalResources,
      visibleWhen: {"field":"storageProvider","value":"externalGCS"}
    },  
       
    {
      attributeName: 'inputFile',      
      storageProvider: 'SFTP',
      type: FormInputTypes.MULTIPLE_UPLOAD_ASYNC,
      label: 'Input file → SFTP',
      helpText: 'Input file is a drag and drop component to browse the file to process in the local machine. Accepted format: mp4',
      required: false,
      defaultInputValue: 'Camera ',
      fileType: ['.mp4'],
      visibleWhen: {"field":"storageProvider","value":"SFTP"}
    },

    {
      attributeName: 'inputFile',
      storageProvider: 'ownS3',
      type: FormInputTypes.MULTIPLE_UPLOAD_ASYNC,
      label: 'Input file → S3',
      helpText: 'Input file is a drag and drop component to browse the file to process in the local machine. Accepted format: mp4',
      required: false,
      defaultInputValue: 'Camera ',
      fileType: ['.mp4'],
      visibleWhen: {"field":"storageProvider","value":"ownS3"}
    },
    {
      attributeName: 'inputFile',
      storageProvider: 'ownGCS',
      type: FormInputTypes.MULTIPLE_UPLOAD_ASYNC,
      label: 'Input file → GCS',
      helpText: 'Input file is a drag and drop component to browse the file to process in the local machine. Accepted format: mp4',
      required: false,
      defaultInputValue: 'Camera ',
      fileType: ['.mp4'],
      visibleWhen: {"field":"storageProvider","value":"ownGCS"}
    },
    
    {
      attributeName: 'type',
      type: FormInputTypes.SELECT,
      label: 'Type',
      helpText: 'Type of video job: Equirectangular, 360º, 180º, flat or control room.',
      errorText: '',
      default: 'globe',
      options: [
        { name: 'Equirectangular', value: 'globe' },
        { name: '180º', value: '180' },
        { name: 'Flat', value: 'flat' },
        { name: 'Control Room', value: 'croom' },
      ],
    },
    {
      attributeName: 'stereoMode',
      type: FormInputTypes.SELECT,
      label: 'Stereo Mode',
      helpText: 'Video format mode: mono, top-bottom, left-right.',
      default: 'mono',
      errorText: '',
      options: [
        { name: 'Mono', value: 'mono' },
        { name: 'Top Bottom', value: 'tb' },
        { name: 'Left Right', value: 'lr' },
      ],
    },
  ],
};
